// extracted by mini-css-extract-plugin
export var container = "Gallery-module--container--9f096";
export var image = "Gallery-module--image--1cddc";
export var imageContainer = "Gallery-module--image-container--8b9d1";
export var images = "Gallery-module--images--7deda";
export var spacer = "Gallery-module--spacer--74223";